<script>
  import { layoutMethods  } from "@/state/helpers";
  // import { contactListData } from "./data-list";
  import { rouletteMethods,rouletteComputed, exportMethods,erpFixMessages, erpUserRolesMethods  } from "@/state/helpers";
  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  export default {
    page: {
      title: "Roulette Item"
    },
    data() {
      return {
        title: "Roulette Item",
        itemListData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Item Prize', value: 'roulette' },
          { text: 'Item Type', value: 'item' }
        ],
        filterOptions: [
          { text: 'All', value: null },
          { text: 'Daily Roleta', value:  'DAILYWHEEL'},
          { text: 'Grand Weekly Roleta', value: 'WEEKLYWHEEL' },
          { text: 'Roleta Promo', value: 'SMARTROLETA' },
        ],
        filterValue: {
            name: null,
            field: 'roulette',
        },
        searchValue: {
            name: null,
            field: null,
        },
        fields: [
          //  {
          //   key: "action",
          //   sortable: true,
          // },
          {
            key: "item_prize",
            sortable: true,
          }, 
          {
            key: "item_status",
            sortable: true,
          },
          {
            key: "roulette_type",
            sortable: true,
          },

          {
            key: "stock",
            sortable: true,
          },
          {
            key: "chance",
            sortable: false,
          },

          {
            key: "type",
            sortable: true,
          },
          {
            key: "image",
            sortable: false,
          },
          // {
          //   key: "backgroud",
          //   sortable: false,
          // },
          {
            key: "amount",
            sortable: false,
          }
        ],
        coinvalue: "",
        statusValue: "",
        typeValue: null,
        datepickervalue: "",
        showModal: false,
        contact: {
          name: "",
          designation: "",
          email: "",
          file: "",
        },
        pagination: {
            "page": 1,
            "rows" : 10,
            "sort": "id",
            "orderDesc": true,
            "search": "",
            "search_field":  "",
            "filter":  "",
            "filter_by": ""
        },
        submitted: false,
        rouletteItemModule: {
          access: {
            create: true
          }
        }
      };
    },
    components: { 
    },
    computed: {
      ...erpFixMessages,
      ...rouletteComputed
    },
    methods: {
      ...layoutMethods,
      ...rouletteMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      async onExport(){
        await this.onPageUpdate();
        if(this.itemTotalRows ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          this.pagination,
          {
            module: 'roulette_items',
            email: JSON.parse(localStorage.getItem('userData')).email
          });

        delete params.page;
        delete params.rows;
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      addEditItem(data){
      // redirect to new page of brand item
        if(data){
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Roulette Edit", params: { id: data.itemId }
            }
          );
        } else {
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Roulette Add", params: {}
            }
          );
        }
       
      },
      populateRouletteItem(){
        //remove existing record
        localStorage.removeItem('roletaItem');
        this.onPageUpdate();
      },
     
      async onPageUpdate() {
          this.pagination.search = this.searchValue.name;
          this.pagination.search_field = this.searchValue.field;
          this.pagination.filter = this.filterValue.name;
          this.pagination.filter_by = this.filterValue.field;
          await this.listRouletteItem(this.pagination)
      },
      refresh(){
        this.searchValue.name = null;
        this.filterValue.name = null;
        //this.pagination.page = 1;
        this.populateRouletteItem();
        
      },
      deleteItem(params){

        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete the '${params.itemName}'. This process cannot be undone!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.value) {

             this.deleteRouletteItem(params.itemId)
              .then(() => {

                this.onPageUpdate();
                Swal.fire("Delete Successful!", `Prize Item ${params.itemName} has been deleted.`,"success");
              })
              .catch((e) => {
                Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                
              });
          }
        });
       
      },
      tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'item_prize' :
                column = 'display_name';
                break;
            case 'item_status' :
                column = 'status';
                break;
            case 'roulette_type' :
                column = 'roulette_type_id';
                break;
            case 'stock' :
                column = 'stock';
                break;
            case 'chance' :
                column = 'chance';
                break;
            case 'type' :
                column = 'type';
                break;
            case 'amount' :
                column = 'amount';
                break;
        }
        this.pagination.sort = column;
        this.pagination.orderDesc = action.sortDesc;
        console.log(this.pagination);
        this.listRouletteItem(this.pagination)
        
      }
    },
    async mounted(){
      this.populateRouletteItem({ rows: 999999, sort: "id", orderDesc: true});
      this.changeTitle({title: 'Roulette Item'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Roulette Item', to: { name: 'Roulette Add'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Roulette', 'Roulette Item')
        .then((access) => this.rouletteItemModule.access = access);

    }
  }
    
</script>

<template>
  <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 mb-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{itemTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-8">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                      <template>
                        <div class="me-2">
                          <b-button v-if="rouletteItemModule.access.create" @click="addEditItem()" variant="primary"><i class="uil uil-plus me-1"></i> Add Prizes</b-button>
                        </div>
                      </template>

                      <a class="btn btn-secondary"
                        @click="refresh"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          >&nbsp;&nbsp; Refresh</a
                      >
                  </div>
              </div>
              <div class="row">
                <div class="w-auto mb-2">
                  <div class="d-flex mt-3 mb-3">
                    <div class="me-3">
                      <form class="d-flex" @submit.prevent="onPageUpdate()">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.field" :options="searchOptions"></b-form-select>
                        </b-form-group>
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                          <b-form-input id="input-keyword" v-model="searchValue.name" class="rounded-0" style="width: auto"></b-form-input>
                        </b-form-group>
                      </form>
                    </div>
                    <div class="me-3 w-250px">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <template v-slot:description><div class="d-flex justify-content-end">Filter By</div></template>
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-3" v-model="filterValue.name" :options="filterOptions"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="me-3">
                      <b-form-group label="">
                        <b-button variant="primary" type="button" @click="onPageUpdate()" class="px-2">
                          <i class='bx bx-search bx-fw'></i>
                          Search
                        </b-button>
                      </b-form-group>
                    </div>
                    <div>
                      <b-form-group label="">
                        <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                          <i class='uil uil-export me-1'></i> Export
                        </b-button>
                      </b-form-group>
                    </div>
                  </div>
                </div>

              <!-- <div class="w-auto mb-2">
                    <div class="d-flex mt-3 mb-3">
                      <div class="me-3">
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Allow Daily Number Spin</div></template>
                        <b-form-input id="input-keyword" v-model="searchValue.name" class="rounded-0" style="width: auto"></b-form-input>
                          
                        </b-form-group>
                      </div>
                      <b-form-group label="">
                      <b-button variant="primary" type="button" @click="onUpdateDailySpin()" class="px-2">
                        <i class='uil openmoji-wheel bx-fw'></i>
                        Update Spin
                      </b-button>
                    </b-form-group>
                    </div>
                    
              </div> -->
                
            </div>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="rouletteItem"
                    :fields="fields"
                    responsive="sm"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="tableSorting"
                    class="table-check"
                  >
                    <!-- <template #cell(action)="data">
                        <div class="d-flex">
                          <div class="btn-group me-2 mb-2 mb-sm-0">
                              <button type="button" @click="addEditItem(data.item)"  class="btn btn-sm btn-primary">
                              <i class="bx bx-edit bx-xs bx-fw"></i>
                              </button>
                          </div>
                          <div>
                              <b-button id="show-btn" @click="deleteItem(data.item)" class="btn btn-sm btn-danger"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                          </div>
                        </div>
                    </template> -->
                    <template #cell(item_prize)="data">
                      <span class="text-body m-0"><router-link :to="{ name: 'Roulette Edit', params: { id: data.item.itemId }}" class="customer-name">{{ data.item.itemName }}</router-link></span>
                       <!-- <p class="mb-0 text-primary" >{{ data.item.itemName }}</p> -->
                    </template>

                    <template #cell(roulette_type)="data">
                       {{ data.item.rouletteName }}
                    </template>
                     <template #cell(item_status)="data">
                      <span :style="[ data.item.itemStatus == 0 ? {color: 'red'} : {color: 'green'} ]">{{data.item.itemStatus == 0 ? 'Deactivated' : 'Activated'}}</span>
                    </template>
                    <template #cell(stock)="data">
                      <span :style="[ data.item.itemStock &lt; 1 && 
                                        (data.item.itemType == 'logistics' || data.item.itemIsEload == 1) ? 
                                        {color: 'red'}  :  
                                      data.item.itemType == 'coins' && data.item.itemIsEload == 0 ? 
                                        {color: 'grey'} : null]">
                          {{ data.item.itemStock &lt; 1 && (data.item.itemType == 'logistics' || 
                            (data.item.itemIsEload == 1 && data.item.itemType == 'coins'))  ? 'out of stock' : 
                              data.item.itemType == 'coins' && data.item.itemIsEload == 0 || 
                              data.item.itemType == 'none' && data.item.itemIsEload == 0 ? 'unavailable'  : 
                              data.item.itemStock + ' pc(s)' }}
                      </span>
                    </template>
                     <template #cell(chance)="data">
                      <span :style="[ data.item.itemStatus == 0 || data.item.itemStock &lt; 1 && 
                                     (data.item.itemType == 'logistics' || data.item.itemType == 'ticket' || data.item.itemIsEload == 1) ? 
                                        {color: 'red'} : {} ]">
                          <b> ({{ data.item.itemChance }})</b> {{ data.item.itemChancePercentage + "%"}}
                      </span>
                       
                    </template>
                    <template #cell(type)="data">
                      {{ (data.item.itemType == 'coins' && data.item.itemIsEload == 0 || 
                              data.item.itemType == 'logistics' || 
                              data.item.itemType == 'ticket' || 
                              data.item.itemType == 'none') ? 
                          (data.item.itemType[0].toUpperCase() + data.item.itemType.slice(1)) : 
                          ('E-Load') }}
                    </template>
                    <template #cell(image)="data">
                      <img :src="data.item.itemIconLink" alt="" class="rounded avatar">
                    </template>
                    <!-- <template #cell(backgroud)="data">
                      <div class="avatar-sm"><div class="avatar-title rounded-circle" :style="{ backgroundColor: data.item.itemBackgroundColor  }"> </div></div>
                    </template> -->
                     <template #cell(amount)="data">
                      {{ data.item.itemType == 'none' ? '' : JSON.parse(data.item.itemRandomizer).random == 1 || 
                        JSON.parse(data.item.itemRandomizer).random == true ? 
                        "(" + JSON.parse(data.item.itemRandomizer).min + " - " + JSON.parse(data.item.itemRandomizer).max + ")" : 
                        data.item.itemType == 'logistics' ? 1 : data.item.itemAmount }} 

                      {{(data.item.itemType == 'coins' && data.item.itemIsEload == 0) ? 'Coin(s)' : 
                         data.item.itemType == 'logistics' ? 'Pc(s)' : 
                         data.item.itemIsEload == 1 ? 'E-Load' : 'No Win'}}
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row g-0 text-center" v-if="itemTotalRows == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="itemTotalRows != 0 && itemTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onPageUpdate()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <div class="row g-0 text-center" v-if="itemTotalRows == 0">
                        <span>No data to display.</span>
                      </div>
                      <b-pagination
                        v-if="itemTotalRows != 0 && itemTotalRows > pagination.rows"
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="itemTotalRows"
                        @input="onPageUpdate()"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
</template>


<style scoped>
  .btn {
    cursor: pointer;
  }
</style>